import type { Dispatch, SetStateAction } from 'react'

import type { MentionItem } from '../../markdown-editor.interface'

export interface KeyboardActionContext {
  itemList: MentionItem[]
  selectedIndex: number
  setSelectedIndex: Dispatch<SetStateAction<number>>
  command: (item: MentionItem) => void
}

const handleArrowUp = ({ itemList, setSelectedIndex }: KeyboardActionContext): boolean => {
  setSelectedIndex((prev) => (prev - 1 + itemList.length) % itemList.length)
  return true
}

const handleArrowDown = ({ itemList, setSelectedIndex }: KeyboardActionContext): boolean => {
  setSelectedIndex((prev) => (prev + 1) % itemList.length)
  return true
}

const handleEnter = ({ itemList, selectedIndex, command }: KeyboardActionContext): boolean => {
  const item = itemList[selectedIndex]
  if (item) {
    command(item)
  }
  return true
}

const handleEscape = (): boolean => true

type KeyboardHandler = (context: KeyboardActionContext) => boolean

const keyboardHandlers: Record<string, KeyboardHandler> = {
  ArrowUp: handleArrowUp,
  ArrowDown: handleArrowDown,
  Enter: handleEnter,
  Escape: handleEscape,
}

export const getKeyboardHandler = (key: string): KeyboardHandler | undefined =>
  keyboardHandlers[key]
